const initialState = {
    cabinetId: 0,
    cabinetIndex: 0, 
};

export default function GetCabinet(state=initialState, action) {
    switch (action.type) {
        case 'REQUEST_FAIL' : {
            return { data: action.payload };
        }
        case 'RESPONSE_LOAD_OK' :
        case 'APPOINTMENT_SERVICE' :
        case 'APPOINTMENT_CABINET' : {
            return Object.assign({}, state, {
                cabinetId: action.cabinetId,
                cabinetIndex: action.cabinetIndex,
            })
        }
        case 'RESPONSE_PARSE_ERROR' : {
            return { data: action.payload };
        }
        default: return state;
    }
}



// WEBPACK FOOTER //
// frontend/src/reducers/GetCabinetId.js